import { render } from "./ZaikoJanListPage.vue?vue&type=template&id=2dcfa5e5"
import script from "./ZaikoJanListPage.vue?vue&type=script&lang=js"
export * from "./ZaikoJanListPage.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1513569783/src/hybrid_inventory_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__